"use client"

import { Button, Text } from "@/elements"
import Link from "next/link"
import { Unlock } from "react-feather"

export const PrivatePortfolioSection: React.FC<{}> = props => {
  return (
    <div className="m-auto flex max-w-[650px] flex-col items-center px-3">
      <div className="flex w-full flex-col items-center justify-center rounded-md bg-bg-1 p-4">
        <Unlock />
        <Text className="my-2" variant="h5">
          View on NOVA
        </Text>
        <Text className="text-fg-1">Sign up to gain access to all Creative profiles</Text>
        <Link href="/sign-up">
          <Button variant="primary" className="mt-3">
            Sign up for NOVA
          </Button>
        </Link>
      </div>
    </div>
  )
}
